// extracted by mini-css-extract-plugin
export const tilt = "home-module--tilt--PiASS";
export const header = "home-module--header--25SFx";
export const headerBefore = "home-module--headerBefore--3fVbW";
export const intro = "home-module--intro--bIM0O";
export const btn = "home-module--btn--2Jhvd";
export const img = "home-module--img--33UXD";